export const environment = {
   production: false,
   name: 'qa'
};
